export default __webpack_public_path__ + "static/media/twitter-1422835925562757125.bb7c5a13.jpg";